import { environment } from '../../../../../../environments/environment';
import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';

import { UsuarioService } from '../../../services/usuario.service';
import { ServicoService } from '../../../services/servico.service'; // adicione o import
import { NgxSpinnerService } from 'ngx-spinner';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { DeviceDetectionService } from '../../../../../shared/services/device-detection.service';
declare var L: any;

@Component({
  selector: 'app-servicos-cadastro',
  standalone: false,
  templateUrl: './servicos-cadastro.component.html',
  styleUrl: './servicos-cadastro.component.css'
})
export class ServicosCadastroComponent implements OnInit {
  getFullImageUrl(url: string): string {
    if (!url) return '';
    if (/^https?:\/\//.test(url)) return url;
    return environment.mediaUrl.replace(/\/$/, '') + (url.startsWith('/') ? url : '/' + url);
  }

  // Formata o número da OS/vistoria (tenta vários campos possíveis)
  formatNumeroOS(item: any): string {
    if (!item) return '-';
    const candidato = item.numeroOS || item.numeroOs || item.numeroOrdem || item.numero || item.ordemNumero || item.numeroOrdemFormatado || item.osNumero || item.osNumero1 || item.osNumero2 || item.osNumero3;
    if (candidato === undefined || candidato === null || candidato === '') return '-';
    const s = candidato.toString();
    // Se contém caracteres não numéricos ou já tem formatação, retorna tal qual
    if (/[^0-9]/.test(s) || /^0+/.test(s)) return s;
    // Pad para 4 dígitos (ex: 14 -> 0014)
    return s.padStart(4, '0');
  }
  // Filtros
  filtroUsuarioId: string = '';
  // Por padrão período vazio
  filtroDataInicio: string = '';
  filtroDataFim: string = '';
  usuariosFiltro: { usuarioId: string, nome: string }[] = [];
  // Filtros adicionais (copiados do servicos.component)
  showFiltros: boolean = false;
  filtroStatus: string = '';
  filtroNumeroOrdem: number | null = null;
  filtroMatricula: string = '';
  filtroNomeConsumidor: string = '';
  filtroCpf: string = '';
  filtroCnpj: string = '';
  filtroCep: string = '';
  filtroLogradouro: string = '';
  filtroBairro: string = '';
  filtroCidade: string = '';
  filtroEstado: string = '';
  filtroNumero: string = '';
  filtroNumeroVistoria: string = '';

  servicos: any[] = [];
  servicosFiltrados: any[] = [];
  carregando = false;
  erro: string | null = null;
  cadastroDetalhes: any = null;
  mostrarModalFoto = false;
  fotoSelecionada = '';

  // Store rotations for photos keyed by URL
  private photoRotations: { [key: string]: number } = {};

  // Referência ao Math para uso no template
  Math = Math;

  // Paginação
  paginaAtual = 1;
  tamanhoPagina = 50;
  totalItens = 0;
  totalPaginas = 0;

  // Local storage key for pagination state (page and page size)
  private readonly PAGINATION_STATE_KEY = 'servicosCadastroPagination';

  @ViewChild('conteudoModal', { static: false }) conteudoModal!: ElementRef;
  htmlCompletoParaExportar: string = '';

  constructor(
    private usuarioService: UsuarioService,
    private servicoService: ServicoService, // injete o service
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private deviceService: DeviceDetectionService
  ) { }

  ngOnInit(): void {
    // Buscar colaboradores e popular filtro
    this.usuarioService.carregarTodosColaboradores().subscribe({
      next: (colaboradores) => {
        this.usuariosFiltro = colaboradores
          .map((u: any) => ({ usuarioId: u.usuarioId, nome: u.nome }))
          .filter(u => !!u.usuarioId && !!u.nome);
      },
      error: () => {
        this.usuariosFiltro = [];
      }
    });

    this.servicos = [];
    this.servicosFiltrados = [];

    // Restaurar filtro de período do localStorage, se existir (igual servicos-pendentes)
    const periodoSalvo = localStorage.getItem('filtroPeriodoServicosCadastro');
    if (periodoSalvo) {
      try {
        const periodo = JSON.parse(periodoSalvo);
        if (periodo && periodo.inicio) this.filtroDataInicio = periodo.inicio;
        if (periodo && periodo.fim) this.filtroDataFim = periodo.fim;
      } catch (e) {
        this.filtroDataInicio = '';
        this.filtroDataFim = '';
      }
    } else {
      this.filtroDataInicio = this.getDataSeteDiasAtrasInput();
      this.filtroDataFim = this.getDataHojeInput();
    }
    // Carrega estado de paginação previamente salvo (se existir)
    try { this.loadPaginationState(); } catch (e) { /* ignore */ }

    // Aplica filtro já com paginação possivelmente restaurada
    this.aplicarFiltro();
  }

  aplicarFiltro(): void {
    this.spinner.show();
    this.erro = null;
    // Nota: não resetar automaticamente a página aqui para manter comportamento
    // de restauração de página salvo em localStorage. Quando o usuário explicitamente
    // alterar o tamanho da página ou resetar filtros, o valor da página será resetado.
    // Fecha a seção de filtros avançados após aplicar
    this.showFiltros = false;
    // Formatar datas para ISO completo (yyyy-MM-ddTHH:mm:ss)
    const dataInicio = this.filtroDataInicio ? this.filtroDataInicio + 'T00:00:00' : undefined;
    const dataFim = this.filtroDataFim ? this.filtroDataFim + 'T23:59:59' : undefined;

    if (!this.filtroUsuarioId) {
      // Quando "Todos" está selecionado, usar o método obterTodosCadastro e enviar os filtros adicionais
      this.servicoService.obterTodosCadastro(
        dataInicio,
        dataFim,
        this.paginaAtual,
        this.tamanhoPagina,
        'Validado',
        this.filtroNomeConsumidor,
        this.filtroCpf,
        this.filtroCnpj,
        this.filtroMatricula,
        this.filtroCep,
        this.filtroLogradouro,
        this.filtroBairro,
        this.filtroCidade,
        this.filtroNumero,
        this.filtroEstado
      ).subscribe({
        next: (response) => {
          this.servicos = response?.itens || response?.items || [];
          this.servicosFiltrados = this.servicos;
          this.aplicarFiltrosLocais();
          this.atualizarInformacoesPaginacao(response);
          this.spinner.hide();
        },
        error: (err) => {
          this.servicos = [];
          this.servicosFiltrados = [];
          this.erro = 'Erro ao buscar cadastros.';
          this.spinner.hide();
        }
      });
      return;
    }

    // Para filtros por usuário, usar obterIntervaloPorUsuarioCadastro (envia status e numero)
    this.servicoService.obterIntervaloPorUsuarioCadastro(
      this.filtroUsuarioId,
      dataInicio,
      dataFim,
      this.paginaAtual,
      this.tamanhoPagina,
      this.filtroStatus,
      this.filtroNumero
    ).subscribe({
      next: (response) => {
        this.servicos = response?.itens || response?.items || response?.cadastros || [];
        this.servicosFiltrados = this.servicos;
        this.aplicarFiltrosLocais();
        this.atualizarInformacoesPaginacao(response);
        this.spinner.hide();
      },
      error: (err) => {
        this.servicos = [];
        this.servicosFiltrados = [];
        this.erro = 'Erro ao buscar cadastros.';
        this.spinner.hide();
      }
    });
  }

  resetarFiltro(): void {
    this.filtroUsuarioId = '';
    // Mantém por padrão período vazio após reset
    this.filtroDataInicio = '';
    this.filtroDataFim = '';
    this.servicos = [];
    this.servicosFiltrados = [];
    this.erro = null;
    // Reset paginação
    this.paginaAtual = 1;
    this.totalItens = 0;
    this.totalPaginas = 0;
    // reset filtros adicionais
    this.showFiltros = false;
    this.filtroStatus = '';
    this.filtroNumeroOrdem = null;
    this.filtroMatricula = '';
    this.filtroNomeConsumidor = '';
    this.filtroCpf = '';
    this.filtroCnpj = '';
    this.filtroCep = '';
    this.filtroLogradouro = '';
    this.filtroBairro = '';
    this.filtroCidade = '';
    this.filtroEstado = '';
    this.filtroNumero = '';
    this.filtroNumeroVistoria = '';
  }

  // Método para resetar e recarregar imediatamente
  resetarERecarregar(): void {
    this.resetarFiltro();
    this.aplicarFiltro();
  }

  // Método para alternar filtros com detecção de mudança
  toggleFiltros(): void {
    this.showFiltros = !this.showFiltros;
    this.cdr.markForCheck();
  }

  private aplicarFiltrosLocais(): void {
    if (!this.servicos || this.servicos.length === 0) {
      this.servicosFiltrados = [];
      return;
    }

    const statusFiltro = (this.filtroStatus || '').toString().trim().toLowerCase();
    const numOrdemFiltro = this.filtroNumeroOrdem;
    const matriculaFiltro = (this.filtroMatricula || '').toString().trim().toLowerCase();
    const nomeFiltro = (this.filtroNomeConsumidor || '').toString().trim().toLowerCase();
    const numeroFiltro = (this.filtroNumeroVistoria || '').toString().trim().toLowerCase();

    this.servicosFiltrados = this.servicos.filter(s => {
      // status
      if (statusFiltro) {
        // Check both 'status' and 'statusOS' (and effectiveStatus) so local filtering matches server behaviour
        const sStatus = (s.status || '').toString().toLowerCase();
        const sStatusOS = (s.statusOS || s.statusOs || s.status_os || '').toString().toLowerCase();
        const eff = (this.effectiveStatus(s) || '').toString().toLowerCase();
        if (!(sStatus.includes(statusFiltro) || sStatusOS.includes(statusFiltro) || eff.includes(statusFiltro))) return false;
      }

      // numero da ordem (aceita campo numeroOrdem, numeroOrdemFormatado ou ordemNumero)
      if (numOrdemFiltro !== null && numOrdemFiltro !== undefined && numOrdemFiltro !== 0) {
        const candidatos = [s.numeroOrdem, s.numeroOrdemFormatado, s.ordemNumero, s.numero];
        const encontrado = candidatos.some((c: any) => c !== undefined && c !== null && c.toString().indexOf(numOrdemFiltro.toString()) !== -1);
        if (!encontrado) return false;
      }

      // matricula
      if (matriculaFiltro) {
        const sMat = (s.matricula || s.matriculaConsumidor || s.matriculaUsuario || '').toString().toLowerCase();
        if (!sMat.includes(matriculaFiltro)) return false;
      }

      // nome consumidor
      if (nomeFiltro) {
        const sNome = (s.nomeConsumidor || s.nome || '').toString().toLowerCase();
        if (!sNome.includes(nomeFiltro)) return false;
      }

      // numero (Nº Vistoria) - comparar com varios campos incluindo numeroOS
      if (numeroFiltro) {
        const candidatosNumero = [
          s.numeroOS, s.numeroOs, s.numeroOrdemFormatado, s.numeroOrdem, s.numero, s.ordemNumero
        ];

        const numeroFiltroSemZeros = numeroFiltro.replace(/^0+/, '');

        const encontradoNumero = candidatosNumero.some((c: any) => {
          if (c === undefined || c === null) return false;
          const cs = c.toString().toLowerCase();
          // comparar tanto com zeros quanto sem zeros à esquerda
          if (cs.includes(numeroFiltro)) return true;
          if (cs.replace(/^0+/, '').includes(numeroFiltroSemZeros)) return true;
          return false;
        });

        if (!encontradoNumero) return false;
      }

      return true;
    });
  }

  alterarTamanhoPagina(novoTamanho: any): void {
    // aceita number ou string vindo do select
    const tamanho = Number(novoTamanho) || 50;
    if (this.tamanhoPagina === tamanho) return;
    this.tamanhoPagina = tamanho;
    // ao mudar o tamanho de página, voltar para a primeira página
    this.paginaAtual = 1;
    // Persistir alteração de tamanho/página
    try { this.savePaginationState(); } catch (e) { /* ignore */ }
    // recarrega com novo tamanho
    this.aplicarFiltro();
  }

  verDetalhes(cadastro: any): void {
    const isTV = this.deviceService.isTV();
    if (isTV) {
      const ZERO_UUID = '00000000-0000-0000-0000-000000000000';
      let idParaBuscar = cadastro.cadastroId && cadastro.cadastroId !== ZERO_UUID ? cadastro.cadastroId : cadastro.id;
      if (!idParaBuscar || idParaBuscar === ZERO_UUID) {
        console.warn('[TV] Nenhum ID válido encontrado para cadastro:', cadastro);
        return;
      }
      this.spinner.show();
      this.servicoService.obterCadastroPorId(idParaBuscar).subscribe({
        next: (detalhes) => {
          const queryParams: any = {};
          if (detalhes?.usuarioId) {
            queryParams.usuarioId = detalhes.usuarioId;
          }
          const idJuncao = detalhes?.idJuncao || detalhes?.IdJuncao || detalhes?.idjuncao || detalhes?.idJuncaoFk;
          if (idJuncao && idJuncao !== ZERO_UUID) {
            queryParams.idJuncao = idJuncao;
            this.servicoService.obterDetalhesporIdJuncao(idJuncao).subscribe({
              next: (detalhesCompletos) => {
                const dataEvento = detalhesCompletos?.dataHoraInicio || detalhes?.dataHoraInicio;
                if (dataEvento) {
                  const day = new Date(dataEvento).toISOString().split('T')[0];
                  queryParams.filtroDataInicio = `${day}T00:00:00`;
                  queryParams.filtroDataFim = `${day}T23:59:59`;
                }
                if (detalhesCompletos?.cadastroId || detalhes?.cadastroId) {
                  queryParams.cadastroId = detalhesCompletos?.cadastroId || detalhes?.cadastroId;
                }
                this.router.navigate(['/admin/roteiro-colaborador'], { queryParams })
                  .finally(() => this.spinner.hide());
              },
              error: (err) => {
                const dataEvento = detalhes?.dataHoraInicio;
                if (dataEvento) {
                  const day = new Date(dataEvento).toISOString().split('T')[0];
                  queryParams.filtroDataInicio = `${day}T00:00:00`;
                  queryParams.filtroDataFim = `${day}T23:59:59`;
                }
                queryParams.cadastroId = idParaBuscar;
                this.router.navigate(['/admin/roteiro-colaborador'], { queryParams })
                  .finally(() => this.spinner.hide());
              }
            });
            return;
          }
          const dataEvento = detalhes?.dataHoraInicio;
          if (dataEvento) {
            const day = new Date(dataEvento).toISOString().split('T')[0];
            queryParams.filtroDataInicio = `${day}T00:00:00`;
            queryParams.filtroDataFim = `${day}T23:59:59`;
          }
          queryParams.cadastroId = idParaBuscar;
          this.router.navigate(['/admin/roteiro-colaborador'], { queryParams })
            .finally(() => this.spinner.hide());
        },
        error: (err) => {
          this.spinner.hide();
          alert('Erro ao carregar detalhes para navegação.');
        }
      });
      return;
    }
    // Caso não seja TV, mantém modal
    this.spinner.show();
    this.cadastroDetalhes = null;
    this.servicoService.obterCadastroPorId(cadastro.cadastroId).subscribe({
      next: (detalhes) => {
        this.spinner.hide();
        this.cadastroDetalhes = detalhes;
        setTimeout(() => this.inicializarMapaCadastro(), 350);
      },
      error: () => {
        this.spinner.hide();
        alert('Erro ao buscar detalhes do cadastro.');
      }
    });
  }

  inicializarMapaCadastro(): void {
    // Remove mapa anterior se existir
    if ((window as any)._mapCadastro) {
      (window as any)._mapCadastro.remove();
      (window as any)._mapCadastro = null;
    }

    const latInicio = this.cadastroDetalhes?.latitudeInicio;
    const lngInicio = this.cadastroDetalhes?.longitudeInicio;
    const latFim = this.cadastroDetalhes?.latitudeFim;
    const lngFim = this.cadastroDetalhes?.longitudeFim;
    const divMapa = document.getElementById('map-cadastro');
    if (!divMapa) return;

    divMapa.innerHTML = '';
    divMapa.style.height = '220px';
    divMapa.style.width = '100%';

    // Só mostra o mapa se pelo menos um ponto existir
    if (latInicio && lngInicio || latFim && lngFim) {
      // Centro do mapa: se ambos, faz média, senão usa o que existir
      let centerLat = latInicio || latFim;
      let centerLng = lngInicio || lngFim;
      if (latInicio && lngInicio && latFim && lngFim) {
        centerLat = (Number(latInicio) + Number(latFim)) / 2;
        centerLng = (Number(lngInicio) + Number(lngFim)) / 2;
      }
      const map = L.map('map-cadastro').setView([centerLat, centerLng], 16);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap'
      }).addTo(map);

      // Marcador início (azul)
      if (latInicio && lngInicio) {
        const inicioIcon = L.icon({
          iconUrl: 'https://cedae.homologacao.vibetex.com.br/images/marcacaoInicio.png',
          iconSize: [48, 48],
          iconAnchor: [24, 48],
          popupAnchor: [0, -45]
        });
        L.marker([latInicio, lngInicio], { icon: inicioIcon }).addTo(map).bindPopup('Início da vistoria');
      }

      // Marcador fim (vermelho)
      if (latFim && lngFim) {
        const fimIcon = L.icon({
          iconUrl: 'https://cedae.homologacao.vibetex.com.br/images/marcacaoFim.png',
          iconSize: [48, 48],
          iconAnchor: [24, 48],
          popupAnchor: [0, -45]
        });
        L.marker([latFim, lngFim], { icon: fimIcon }).addTo(map).bindPopup('Fim da vistoria');
      }

      (window as any)._mapCadastro = map;
    } else {
      divMapa.innerHTML = '<div style="text-align:center;padding:40px 0;color:#888;">Sem coordenadas para exibir o mapa.</div>';
      divMapa.style.height = '120px';
    }
  }

  fecharModalDetalhes(): void {
    this.cadastroDetalhes = null;
  }

  abrirModalFoto(url: string): void {
    this.fotoSelecionada = this.getFullImageUrl(url);
    this.mostrarModalFoto = true;
  }

  /** Rotate a photo by delta degrees (multiples of 90) */
  rotatePhoto(url: string | undefined, delta: number): void {
    if (!url) return;
    const key = url;
    const current = this.photoRotations[key] || 0;
    const normalized = Math.round(delta / 90) * 90;
    let next = (current + normalized) % 360;
    if (next < 0) next += 360;
    this.photoRotations[key] = next;
  }

  /** Get current rotation for photo (degrees) */
  getPhotoRotation(url: string | undefined): number {
    if (!url) return 0;
    return this.photoRotations[url] || 0;
  }

  fecharModalFoto(): void {
    this.mostrarModalFoto = false;
    this.fotoSelecionada = '';
  }

  exportarCadastroParaPDF(): void {
    if (!this.cadastroDetalhes) return;

    // Salva os dados do serviço antes de fechar o modal
    const dadosServico = { ...this.cadastroDetalhes };

    // Busca o modal-body original
    const modalBodyOriginal = document.querySelector('.modal-body') as HTMLElement;
    if (!modalBodyOriginal) return;

    // Cria um clone do modal-body para captura
    const modalBodyClone = modalBodyOriginal.cloneNode(true) as HTMLElement;

    // Configura o clone para captura completa mas visível para html2canvas
    modalBodyClone.style.position = 'absolute';
    modalBodyClone.style.top = '-9999px';
    modalBodyClone.style.left = '-9999px';
    modalBodyClone.style.overflow = 'visible';
    modalBodyClone.style.maxHeight = 'none';
    modalBodyClone.style.height = 'auto';
    modalBodyClone.style.width = modalBodyOriginal.offsetWidth + 'px';
    modalBodyClone.style.visibility = 'visible';
    modalBodyClone.style.pointerEvents = 'none';
    modalBodyClone.style.opacity = '1';

    // Adiciona o clone ao body temporariamente
    document.body.appendChild(modalBodyClone);

    // Fecha o modal imediatamente para melhor UX
    this.fecharModalDetalhes();

    // Aguarda um momento para o clone renderizar completamente
    setTimeout(() => {
      html2canvas(modalBodyClone, {
        scale: 1,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        scrollX: 0,
        scrollY: 0,
        logging: true,
        width: modalBodyClone.scrollWidth,
        height: modalBodyClone.scrollHeight
      }).then((canvas: HTMLCanvasElement) => {
        // Remove o clone após a captura
        document.body.removeChild(modalBodyClone);


        const pdf = new jsPDF('p', 'mm', 'a4');
        const pdfWidth = 210;
        const pdfHeight = 297;
        const margin = 8;
        const contentWidth = pdfWidth - (margin * 2);
        const pageContentHeight = pdfHeight - (margin * 2);

        // Proporção da imagem para o PDF
        const imgWidth = contentWidth;
        const imgHeight = (canvas.height * contentWidth) / canvas.width;

        // Altura do canvas em pixels correspondente a uma página PDF
        const pageHeightPx = Math.floor((pageContentHeight * canvas.height) / imgHeight);
        const minRestPx = 100; // altura mínima para não cortar elemento grande
        let renderedHeight = 0;
        let pageNum = 1;

        while (renderedHeight < canvas.height) {
          let pageCanvasHeight = Math.min(pageHeightPx, canvas.height - renderedHeight);
          // Se o restante do canvas for menor que minRestPx, pule para próxima página
          if (canvas.height - (renderedHeight + pageCanvasHeight) < minRestPx && (canvas.height - renderedHeight) > pageHeightPx) {
            pageCanvasHeight = canvas.height - renderedHeight - minRestPx;
          }

          const pageCanvas = document.createElement('canvas');
          const pageCtx = pageCanvas.getContext('2d');
          pageCanvas.width = canvas.width;
          pageCanvas.height = pageCanvasHeight;

          // Copia a parte do canvas para a página
          pageCtx?.drawImage(
            canvas,
            0, renderedHeight, canvas.width, pageCanvasHeight,
            0, 0, canvas.width, pageCanvasHeight
          );

          const pageImgData = pageCanvas.toDataURL('image/png');
          const pageImgHeight = (pageCanvasHeight * imgWidth) / canvas.width;

          if (pageNum > 1) pdf.addPage();
          pdf.addImage(pageImgData, 'PNG', margin, margin, imgWidth, pageImgHeight);

          renderedHeight += pageCanvasHeight;
          pageNum++;
        }

        // Usa os dados salvos para o nome do arquivo
        const nome = dadosServico?.nomeConsumidor?.replace(/\s/g, '_') || 'servico';
        pdf.save(`${nome}_servico.pdf`);
      }).catch((error: any) => {
        console.error('Erro ao gerar PDF:', error, error?.message, error?.stack);
        // Remove o clone em caso de erro
        if (document.body.contains(modalBodyClone)) {
          document.body.removeChild(modalBodyClone);
        }
        alert('Erro ao gerar o PDF. Tente novamente.');
      });
    }, 500);
  }
  onFiltroDataFimChange(): void {
    // Persiste filtro de período no localStorage (igual servicos-pendentes)
    localStorage.setItem('filtroPeriodoServicosCadastro', JSON.stringify({
      inicio: this.filtroDataInicio,
      fim: this.filtroDataFim
    }));

    // If no end date selected, do nothing (user may be clearing the filter)
    if (!this.filtroDataFim) {
      return;
    }

    // Allow the ngModel binding to settle, then apply the filter.
    setTimeout(() => {
      try {
        this.aplicarFiltro();
      } catch (e) {
        // swallow to avoid breaking UI; spinner/error handling is inside aplicarFiltro
        console.error('Erro ao aplicar filtro automaticamente por data fim', e);
      }
    }, 50);
  }
  // Persiste filtro de período ao alterar data início (igual servicos-pendentes)
  onFiltroDataInicioChange(): void {
    localStorage.setItem('filtroPeriodoServicosCadastro', JSON.stringify({
      inicio: this.filtroDataInicio,
      fim: this.filtroDataFim
    }));
  }

  getDataHojeInput(): string {
    const hoje = new Date();
    return hoje.toISOString().split('T')[0];
  }

  getDataSeteDiasAtrasInput(): string {
    const hoje = new Date();
    const seteDiasAtras = new Date(hoje);
    // Use inclusive last 7 days: today and the 6 previous days -> subtract 7 to get start date 7 days ago
    seteDiasAtras.setDate(hoje.getDate() - 0);
    return seteDiasAtras.toISOString().split('T')[0];
  }

  maskCpf(cpf: string): string {
    if (!cpf) return '-';
    cpf = cpf.replace(/\D/g, '');
    if (cpf.length !== 11) return cpf;
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  maskCnpj(cnpj: any): string {
    if (!cnpj) return '-';
    cnpj = String(cnpj).replace(/\D/g, '');
    if (cnpj.length !== 14) return cnpj;
    return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }

  maskTelefone(telefone: string): string {
    if (!telefone) return '-';
    telefone = telefone.replace(/\D/g, '');
    if (telefone.length === 11) {
      return telefone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }
    if (telefone.length === 10) {
      return telefone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }
    return telefone;
  }

  /**
   * Normaliza vários formatos de valor 'afirmativo' para uso no template.
   * Retorna true para: boolean true, strings 'true', 'sim', 's', '1', 'yes' (case-insensitive) e números 1.
   */
  isAffirmative(value: any): boolean {
    if (value === undefined || value === null) return false;
    if (typeof value === 'boolean') return value;
    if (typeof value === 'number') return value === 1;
    const s = String(value).trim().toLowerCase();
    return s === 'true' || s === 'sim' || s === 's' || s === '1' || s === 'yes' || s === 'y';
  }

  cadastroTipoUtilizacaoDomiciliar(): boolean {
    // Retorna true se todos os cadastros filtrados são domiciliares
    return this.servicosFiltrados.every(c => c.tipoUtilizacao === 'DOMICILIAR');
  }

  // Métodos de paginação
  private atualizarInformacoesPaginacao(response: any): void {
    this.totalItens = response?.totalItens || 0;
    this.totalPaginas = response?.totalPaginas || 0;
    this.paginaAtual = response?.paginaAtual || 1;
    this.tamanhoPagina = response?.tamanhoPagina || 10;
  }

  irParaPagina(pagina: number): void {
    if (pagina >= 1 && pagina <= this.totalPaginas && pagina !== this.paginaAtual) {
      this.paginaAtual = pagina;
      try { this.savePaginationState(); } catch (e) { /* ignore */ }
      this.carregarPagina();
    }
  }

  paginaAnterior(): void {
    if (this.paginaAtual > 1) {
      this.paginaAtual--;
      try { this.savePaginationState(); } catch (e) { /* ignore */ }
      this.carregarPagina();
    }
  }

  proximaPagina(): void {
    if (this.paginaAtual < this.totalPaginas) {
      this.paginaAtual++;
      try { this.savePaginationState(); } catch (e) { /* ignore */ }
      this.carregarPagina();
    }
  }

  /**
   * Persiste a página atual e o tamanho da página no localStorage.
   */
  private savePaginationState(): void {
    try {
      const payload = {
        paginaAtual: Number(this.paginaAtual) || 1,
        tamanhoPagina: Number(this.tamanhoPagina) || 50
      };
      localStorage.setItem(this.PAGINATION_STATE_KEY, JSON.stringify(payload));
    } catch (e) {
      // ignore storage errors
      console.warn('[WARN] Não foi possível salvar estado de paginação (cadastro)', e);
    }
  }

  /**
   * Carrega o estado de paginação salvo (se existir) e aplica aos campos.
   */
  private loadPaginationState(): void {
    try {
      const raw = localStorage.getItem(this.PAGINATION_STATE_KEY);
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (!parsed) return;
      const tamanho = Number(parsed.tamanhoPagina);
      const pagina = Number(parsed.paginaAtual);
      if (tamanho && !Number.isNaN(tamanho)) this.tamanhoPagina = tamanho;
      if (pagina && !Number.isNaN(pagina)) this.paginaAtual = pagina;
    } catch (e) {
      // ignore parse errors
    }
  }

  private carregarPagina(): void {
    this.spinner.show();

    if (!this.filtroUsuarioId) {
      // Para "Todos", recarrega com paginação
      const dataInicio = this.filtroDataInicio ? this.filtroDataInicio + 'T00:00:00' : undefined;
      const dataFim = this.filtroDataFim ? this.filtroDataFim + 'T23:59:59' : undefined;
      // same reorder for pagination path
      this.servicoService.obterTodosCadastro(dataInicio, dataFim, this.paginaAtual, this.tamanhoPagina, 'Validado', this.filtroNomeConsumidor, this.filtroCpf, this.filtroCnpj, this.filtroMatricula, this.filtroCep, this.filtroLogradouro, this.filtroBairro, this.filtroCidade, this.filtroNumero, this.filtroEstado).subscribe({
        next: (response) => {
          this.servicos = response?.itens || response?.items || [];
          this.servicosFiltrados = this.servicos;
          this.atualizarInformacoesPaginacao(response);
          this.spinner.hide();
        },
        error: (err) => {
          this.servicos = [];
          this.servicosFiltrados = [];
          this.erro = 'Erro ao buscar cadastros.';
          this.spinner.hide();
        }
      });
    } else {
      // Para filtros específicos por usuário, também usa paginação
      const dataInicio = this.filtroDataInicio ? this.filtroDataInicio + 'T00:00:00' : undefined;
      const dataFim = this.filtroDataFim ? this.filtroDataFim + 'T23:59:59' : undefined;

      this.servicoService.obterIntervaloPorUsuarioCadastro(
        this.filtroUsuarioId,
        dataInicio,
        dataFim,
        this.paginaAtual,
        this.tamanhoPagina,
        this.filtroStatus,
        this.filtroNumero
      ).subscribe({
        next: (response) => {
          this.servicos = response?.itens || response?.items || response?.cadastros || [];
          this.servicosFiltrados = this.servicos;
          this.atualizarInformacoesPaginacao(response);
          this.spinner.hide();
        },
        error: (err) => {
          this.servicos = [];
          this.servicosFiltrados = [];
          this.erro = 'Erro ao buscar cadastros.';
          this.spinner.hide();
        }
      });
    }
  }

  // Método para gerar array de páginas para o paginador
  obterPaginas(): number[] {
    const paginas = [];
    const maxPaginasVisiveis = 5;
    const metade = Math.floor(maxPaginasVisiveis / 2);

    let inicio = Math.max(1, this.paginaAtual - metade);
    let fim = Math.min(this.totalPaginas, inicio + maxPaginasVisiveis - 1);

    // Ajusta o início se estivermos próximos do fim
    if (fim - inicio < maxPaginasVisiveis - 1) {
      inicio = Math.max(1, fim - maxPaginasVisiveis + 1);
    }

    for (let i = inicio; i <= fim; i++) {
      paginas.push(i);
    }

    return paginas;
  }

  effectiveStatus(servico: any): string {
    if (!servico) return '';
    const statusRaw = (servico.status || '').toString();
    const status = statusRaw.toLowerCase();
    const statusOS = (servico.statusOS || servico.statusOs || servico.status_os || '').toString();

    // Se status indica um dos casos em que devemos priorizar o próprio status:
    if (['analisando', 'validado', 'invalido'].includes(status)) {
      return statusRaw;
    }

    if (statusOS) return statusOS;

    return statusRaw || '';
  }
}